var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_2297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 7.93141C15.4297 7.77278 15.3977 7.61566 15.3347 7.47006C15.2718 7.32446 15.1792 7.19356 15.0628 7.0857L8.00001 0.571411L0.937152 7.0857C0.820837 7.19356 0.728252 7.32446 0.665289 7.47006C0.602325 7.61566 0.570364 7.77278 0.571437 7.93141V14.2857C0.571437 14.5888 0.691845 14.8795 0.906172 15.0938C1.1205 15.3081 1.41119 15.4286 1.71429 15.4286H14.2857C14.5888 15.4286 14.8795 15.3081 15.0938 15.0938C15.3082 14.8795 15.4286 14.5888 15.4286 14.2857V7.93141Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.4286V10.8572",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_2297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.9b3532b387699c13fb3d78ecea392c90.svg";
export { ForwardRef as ReactComponent };